import ChartVariant from '@opsbase/lib-chart/ChartVariant';
import findGroupByKey from '@opsbase/lib-data-query/helpers/findGroupByKey';
import useDataTree from '@opsbase/web-ctrl-datatree/useDataTree';
import useView from '@opsbase/web-ctrl-view/useView';
import CountGroupChart from '@opsbase/web-data-chart/CountGroupChart';
import CountGroupTimeChart from '@opsbase/web-data-chart/CountGroupTimeChart';
import CountTimeChart from '@opsbase/web-data-chart/CountTimeChart';
import calcTitleForChart from '@opsbase/web-data-chart/helpers/calcTitleForChart';
import ScoreQOpChart from '@opsbase/web-data-chart/ScoreQOpChart';
import React from 'react';
import ViewReportChartWrapper from './ViewReportChartWrapper';
export function ViewReportChartBox() {
    const dt = useDataTree();
    const view = useView(dt.viewId);
    return (React.createElement(React.Fragment, null, view.chartBox.charts
        .filter(chart => !chart.hidden)
        .map((chart, idx) => {
        var _a, _b;
        const wrapperProps = {
            key: 'chart' + idx,
            groupBy: undefined,
            title: calcTitleForChart(view, chart),
        };
        const highlightXId = (_b = (_a = view.highlightedDateRange) === null || _a === void 0 ? void 0 : _a.from) === null || _b === void 0 ? void 0 : _b.toDate().getTime();
        const chartProps = {
            key: chart.chartType + idx,
            chart,
            fontSize: 16,
        };
        switch (chart.chartVariant) {
            case ChartVariant.COUNT_GROUP:
                wrapperProps.groupBy = findGroupByKey(view.groupBys, chart.config.dimension);
                return (React.createElement(ViewReportChartWrapper, { ...wrapperProps, width: 400 },
                    React.createElement(CountGroupChart, { ...chartProps, width: 400, height: 400 })));
            case ChartVariant.COUNT_TIME:
                return (React.createElement(ViewReportChartWrapper, { ...wrapperProps },
                    React.createElement(CountTimeChart, { ...chartProps, width: 600, height: 400 })));
            case ChartVariant.COUNT_GROUP_TIME:
                wrapperProps.groupBy = findGroupByKey(view.groupBys, chart.config.otherDimension);
                return (React.createElement(ViewReportChartWrapper, { ...wrapperProps },
                    React.createElement(CountGroupTimeChart, { ...chartProps, highlightXId: highlightXId, width: 600, height: 400 })));
            case ChartVariant.SCORE_Q_OP:
                return (React.createElement(ViewReportChartWrapper, { ...wrapperProps },
                    React.createElement(ScoreQOpChart, { ...chartProps, width: 600, height: 400 })));
        }
    })));
}
export default ViewReportChartBox;
